import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { MoreHorizontal } from "lucide-react"
import React from "react"
import { DeleteConversationModal } from "@/components/feature/Modals/DeleteConversationModal/DeleteConversationModal"
import { RenameConversationDialog } from "./RenameConversationDialog"

interface ConversationActionsProps {
  conversationId: string
  title: string
  compact?: boolean
  showOnHover?: boolean
  onRenameInline?: () => void
}

export const ConversationActions: React.FC<ConversationActionsProps> = ({
  conversationId,
  title,
  compact = false,
  showOnHover = false,
  onRenameInline,
}) => {
  const { translate } = useTranslation()

  const [isRenameOpen, setIsRenameOpen] = React.useState(false)
  const [isDeleteOpen, setIsDeleteOpen] = React.useState(false)
  const suppressCloseAutoFocusRef = React.useRef(false)

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className={
              showOnHover
                ? "rounded p-1 transition-opacity hover:bg-sidebar-accent focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-sidebar-ring md:opacity-0 md:pointer-events-none md:group-hover/item:opacity-100 md:group-hover/item:pointer-events-auto focus:opacity-100 focus:pointer-events-auto focus-visible:opacity-100 focus-visible:pointer-events-auto data-[state=open]:opacity-100 data-[state=open]:pointer-events-auto"
                : "rounded p-1 hover:bg-sidebar-accent focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-sidebar-ring"
            }
            onClick={(event) => event.stopPropagation()}
            aria-label={translate("AI_CHAT/HISTORY/OPTIONS")}
          >
            <MoreHorizontal className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="w-44"
          onCloseAutoFocus={(event) => {
            if (!suppressCloseAutoFocusRef.current) {
              return
            }

            event.preventDefault()
            suppressCloseAutoFocusRef.current = false
          }}
        >
          <DropdownMenuItem
            onSelect={(event) => {
              event.stopPropagation()
              if (onRenameInline) {
                suppressCloseAutoFocusRef.current = true
                onRenameInline()
                return
              }
              setIsRenameOpen(true)
            }}
          >
            {translate("AI_CHAT/HISTORY/RENAME")}
          </DropdownMenuItem>
          <DropdownMenuItem
            onSelect={(event) => {
              event.stopPropagation()
              setIsDeleteOpen(true)
            }}
          >
            {translate("AI_CHAT/HISTORY/DELETE")}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {isRenameOpen && (
        <RenameConversationDialog
          conversationId={conversationId}
          currentTitle={title}
          isOpen={isRenameOpen}
          setIsOpen={setIsRenameOpen}
        />
      )}

      {isDeleteOpen && (
        <DeleteConversationModal
          conversationId={conversationId}
          setIsDeleteModalOpen={setIsDeleteOpen}
        />
      )}
    </>
  )
}
